import {Routing} from './fos-router-hacked';
const routes = require('../../../web/js/fos_js_routes.json');
Routing.setRoutingData(routes);

export default Routing;
